<template>
  <div class="userinfo-main">
      <div class="head">
          <img :src="info.headimgurl" alt="">
          <h3>{{info.nickname}}</h3>
      </div>
      <!--  -->
      <div class="content">
          <h4>已购票信息</h4>

<!--          <div v-show="info.user_id==671865" class="list">-->
<!--            <div class="title" style="font-weight: bold;font-size:0.45rem;">第13届做自己节+知识市集活动</div>-->
<!--            <br>-->
<!--            <div class="title">做自己节：<span style="color: #ff0000">门票校验码 < <span style="font-weight: bold;font-size:0.8rem;">1</span> ></span></div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心</div>-->
<!--            <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·9:00-18:00</div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：新路(13866668888) 下方二维码添加↓</div>-->
<!--            <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode.jpg" alt=""></div>-->
<!--            <div class="list-title"></div>-->
<!--            <br>-->
<!--            <div class="title">超级个体资源碰撞晚宴：</div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心</div>-->
<!--            <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·19:00-21:00</div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：新路(13866668888) 下方二维码添加↓</div>-->
<!--            <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode.jpg" alt=""></div>-->
<!--            <div class="list-title"></div>-->
<!--            <br>-->
<!--            <div class="title">超级个体大课：</div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心</div>-->
<!--            <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月17日-1月18日·9:00-18:00(2天1晚)</div>-->
<!--            <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：新路(13866668888) 下方二维码添加↓</div>-->
<!--            <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode.jpg" alt=""></div>-->
<!--          </div>-->


          <div @click="showProductSucc(item)" v-for="(item,index) in list" :key="index" class="list">
            <div class="title" style="font-weight: bold;font-size:0.45rem;">{{item.product_name}}</div>
            <br>

            <div v-show="item.product_id==326 || item.product_id==327 || item.product_id==328 || item.product_id==329 || item.product_id==331 || item.product_id==333 || item.product_id==334 || item.product_id==335 || item.product_id==336 || item.product_id==337 || item.product_id==338 || item.product_id==339 || item.product_id==340 || item.product_id==341 || item.product_id==342 || item.product_id==343 || item.product_id==344 || item.product_id==345 || item.product_id==346 || item.product_id==347 || item.product_id==348 || item.product_id==349 || item.product_id==350">
              <div class="title">做自己节门票：<span style="color: #ff0000">校验码 < <span style="font-weight: bold;font-size:0.7rem;">{{item.code}}</span> ></span></div>
              <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心一层</div>
              <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·9:00-18:00</div>
<!--              <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：新路(识别下方二维码添加↓)</div>-->
<!--              <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202601.jpg" alt=""></div>-->
              <div class="list-title"></div>
              <br>
            </div>

            <div v-show="item.product_id==329 || item.product_id==330">
              <div class="title">超级个体资源碰撞晚宴：</div>
              <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心宴会厅</div>
              <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月16日·19:00-21:00</div>
<!--              <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：小美(识别下方二维码添加↓)</div>-->
<!--              <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202602.jpg" alt=""></div>-->
              <div class="list-title"></div>
              <br>
            </div>

            <div v-show="item.product_id==328 || item.product_id==330 || item.product_id==331 || item.product_id==333 || item.product_id==334 || item.product_id==335 || item.product_id==336 || item.product_id==337 || item.product_id==348">
              <div class="title">超级个体大课：<span style="color:#00a3ff;">校验码 < <span style="font-weight: bold;font-size:0.7rem;">{{item.code2}}</span> ></span></div>
              <div class="row"><img class="img1" src="@a/be-myself/2020/city-min.png" alt="">广州越秀国际会议中心602国际会议厅BC</div>
              <div class="row"><img class="img2" src="@a/be-myself/2020/time.png" alt="">1月17日-1月18日·9:00-18:00(2天1晚)</div>
<!--              <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：小美(识别下方二维码添加↓)</div>-->
<!--              <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202603.jpg" alt=""></div>-->
              <div class="list-title"></div>
              <br>
            </div>


            <div v-show="item.product_id==326 || item.product_id==327 || item.product_id==338 || item.product_id==339 || item.product_id==340 || item.product_id==341 || item.product_id==342 || item.product_id==343 || item.product_id==344 || item.product_id==345 || item.product_id==346 || item.product_id==347 || item.product_id==349 || item.product_id==350">
              <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：小昭(识别下方二维码添加↓)</div>
              <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202601.jpg" alt=""></div>
            </div>
            <div v-show="item.product_id==328 || item.product_id==329 || item.product_id==330 || item.product_id==331 || item.product_id==333 || item.product_id==334 || item.product_id==335 || item.product_id==336 || item.product_id==337 || item.product_id==348">
              <div class="row"><img class="img1" src="@a/be-myself/2020/user.png" alt="">负责人：小美(识别下方二维码添加↓)</div>
              <div class="row"><img style="width:150px;height: 150px;" src="https://misc.xjy.cn/zuoziji/zzj_qrcode_202603.jpg" alt=""></div>
            </div>



          </div>
      </div>
      <!-- 引入组件 -->
    <buying-tickets-success v-if="buyTikShow"  :oid="oid" :name="name" :phone="phone" :price="discount_price?discount_price/100:((item.price/100)>0?(item.price/100):0)" :itemObj="item" class="buy-scssess"></buying-tickets-success>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { orderList,userInfo } from "@/api/be_myself"
import BuyingTicketsSuccess from "../buying_tickets_success/index"
export default {
    data(){
        return{
            loading: false,
            finished: false,
            error: false,
            list:[],
            pages:{
                page: 0,
                size: 10,
            },
            user_id:null,
            info:{},
            productUser:[],
            //
            name:'',
            phone:null,
            item:{},
            coupon:'',
            discount_price:null,
            buyTikShow:false,
            oid:null
        }
    },
    components: {
        BuyingTicketsSuccess
    },
    methods:{
        // 显示购买成功信息
        showProductSucc(row){
            this.discount_price = row.product_price;
            this.item = row;
            this.oid = row.id;
            this.name = row.name;
            this.phone = row.phone;
            this.buyTikShow = true;
        },
        // 获取用户信息
        getUserInfo(){
            // 获取用户信息
            userInfo().then((data)=>{
                this.info = data;
                this.user_id = data.user_id;
                this.getListData();
            });
        },
        // 获取已购信息
        pullData(){
            if(this.user_id){
                this.getListData();
            }else{
                this.getUserInfo();
            }
        },
        // 获取列表信息
        getListData(){
             //调用加载中
            this.$emit('loadingHandle',true,"超级个体，更值钱更热爱更自在(σ≧∀≦σ)");
            this.pages.page += 1;
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:1,//做自己节传1
                status:1,
                user_id:this.user_id
            };
            orderList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.pages = data.pager;

                this.list = Array.from(new Set([...this.list,...data.list]));

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if(data.pager.page_count == data.pager.page) {
                    this.finished = true;
                }
            }).catch(err=>{
                this.error = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon("beMyself", this);
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>

.userinfo-main{
    display: flex;
    flex-direction: column;
    .buy-scssess{
        position: fixed;
        width: 100%;
        max-width: 750px;
        min-height: 100%;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 888;
        background-color: #F5F5F5;
    }
    .head{
        display: flex;
        flex-direction: column;
        align-items: center;
        // margin-bottom: 8px;
        background-color: #ffffff;
        padding: 30px 0;
        border-bottom: 8px solid #f0f0f0;
        img{
            width: 120px;
            height: 120px;
            border-radius: 50%;
        }
        h3{
            font-size: 32px;
            color: #333333;
            line-height: 48px;
            margin: 28px auto 0;
        }
    }
    .content{
        background-color: #ffffff;
        padding: 30px 24px;
        h4{
            font-size: 28px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
            margin-bottom: 30px;
        }
        .list-title{
          border: 1px solid #cbcbcb;
        }
        .list{
            display: flex;
            flex-direction: column;
            padding: 24px;
            border-radius: 8px;
            //border: 2px solid #E4E4E4;
            border: 2px solid #d3d3d3;
            box-shadow: 1px 2px 12px rgba(0, 0, 0, 0.3);
            margin-bottom: 20px;
            .title{
                font-size: 28px;
                font-weight: 600;
                color: #333333;
                line-height: 40px;
                margin-bottom: 30px;
            }
            .row{
                display: flex;
                align-items: center;
                font-size: 28px;
                color: #333;
                margin-bottom: 24px;
                line-height: 40px;
                .img1{
                    width: 30px;
                    margin-right: 8px;
                }
                .img2{
                    width: 27px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>
